import React from 'react';
import Tooltip from './index';
import { Icons } from '@/assets';
import { Icon } from '../Icon';

const TooltipIcon = ({
  tooltipId,
  iconId,
  content,
  position = 'top',
  width = 20,
  height = 20,
}) => {
  return (
    <Tooltip
      tooltipId={tooltipId}
      iconId={iconId}
      content={content}
      position={position}>
      <Icon src={Icons.infoGray} width={width} height={height} />
    </Tooltip>
  );
};

export default TooltipIcon;
